const triggerDownload = (url: string, name: string, revoke = false) => {
  const link = Object.assign(document.createElement('a'), {
    href: url,
    download: name,
    target: '_blank',
    rel: 'noopener noreferrer',
    style: 'display:none',
  });
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  if (revoke) setTimeout(() => URL.revokeObjectURL(url), 5000);
};

export const fileDownloader = (file: File | string, fileName?: string) => {
  if (typeof file === 'string') {
    const name = fileName || file.split('/').pop()?.split('?')[0] || 'file';
    triggerDownload(file, name);
  } else {
    triggerDownload(URL.createObjectURL(file), fileName ?? file.name, true);
  }
};